var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlankDataThumb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 480,
    viewBox: "0 0 420 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335.494 394.028C335.494 405.358 325.199 414.546 312.494 414.546H24.994C12.294 414.546 2 405.358 2 394.028V22.518C2 11.187 12.3 2 24.994 2H312.494C325.194 2 335.494 11.187 335.494 22.518V394.028Z",
    fill: "white",
    stroke: "#BCBCBC",
    strokeWidth: 2.592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M418.446 123.868V450.794C418.439 458.231 415.482 465.362 410.223 470.621C404.964 475.88 397.833 478.837 390.396 478.843H89.669C82.2311 478.841 75.0984 475.885 69.8395 470.625C64.5805 465.365 61.6258 458.232 61.625 450.794V95.5411C61.6237 91.8579 62.3482 88.2104 63.757 84.8073C65.1659 81.4041 67.2315 78.3119 69.8358 75.7074C72.4402 73.1029 75.5323 71.037 78.9353 69.6279C82.3384 68.2188 85.9858 67.4941 89.669 67.4951H362.091L418.446 123.868Z",
    fill: "white",
    stroke: "#BCBCBC",
    strokeWidth: 2.194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M418.445 123.868V126.436C408.862 129.172 367.47 140.346 356.199 132.022C346.058 124.542 355.571 79.6221 358.374 67.4951H362.09L418.445 123.868Z",
    fill: "white",
    stroke: "#BCBCBC",
    strokeWidth: 2.194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M158.445 178.796C158.444 183.418 157.072 187.936 154.503 191.778C151.934 195.621 148.284 198.615 144.013 200.383C139.743 202.151 135.044 202.613 130.511 201.71C125.978 200.808 121.814 198.581 118.546 195.313C115.278 192.044 113.053 187.88 112.152 183.346C111.25 178.813 111.714 174.114 113.483 169.844C115.251 165.574 118.247 161.925 122.09 159.357C125.933 156.789 130.451 155.418 135.073 155.418C138.143 155.417 141.183 156.022 144.019 157.197C146.855 158.371 149.432 160.093 151.603 162.264C153.773 164.435 155.495 167.013 156.669 169.849C157.843 172.686 158.446 175.726 158.445 178.796V178.796Z",
    fill: "#444444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M158.445 272.989C158.445 277.611 157.074 282.13 154.506 285.973C151.938 289.817 148.288 292.812 144.018 294.581C139.748 296.35 135.049 296.813 130.515 295.911C125.982 295.009 121.817 292.784 118.549 289.515C115.28 286.247 113.054 282.083 112.152 277.549C111.25 273.016 111.713 268.317 113.482 264.046C115.251 259.776 118.246 256.126 122.089 253.557C125.932 250.989 130.451 249.618 135.073 249.618C138.142 249.618 141.182 250.222 144.018 251.396C146.853 252.57 149.43 254.292 151.6 256.462C153.771 258.632 155.492 261.209 156.667 264.045C157.841 266.881 158.446 269.92 158.445 272.989V272.989Z",
    fill: "#444444"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M161.008 367.541C161.008 372.164 159.637 376.683 157.069 380.526C154.5 384.37 150.85 387.366 146.579 389.135C142.308 390.904 137.609 391.367 133.075 390.465C128.541 389.563 124.376 387.337 121.108 384.068C117.839 380.799 115.613 376.635 114.711 372.101C113.809 367.567 114.272 362.867 116.041 358.596C117.81 354.326 120.806 350.675 124.649 348.107C128.493 345.539 133.012 344.168 137.635 344.168C143.833 344.169 149.778 346.631 154.161 351.015C158.544 355.398 161.007 361.342 161.008 367.541Z",
    fill: "#444444"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.188 179.702L133.213 186.728L149.085 170.86",
    stroke: "white",
    strokeWidth: 4.674,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.945 274.977L130.977 282.001L146.836 266.135",
    stroke: "white",
    strokeWidth: 4.674,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.188 368.452L133.213 375.473L149.085 359.61",
    stroke: "white",
    strokeWidth: 4.674,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.367 165.912H325.155",
    stroke: "#BCBCBC",
    strokeWidth: 2.194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.434 191.679H360.789",
    stroke: "#BCBCBC",
    strokeWidth: 2.194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M188.367 260.106H325.155",
    stroke: "#BCBCBC",
    strokeWidth: 2.194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M189.434 285.874H360.789",
    stroke: "#BCBCBC",
    strokeWidth: 2.194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188.367 354.934H325.155",
    stroke: "#BCBCBC",
    strokeWidth: 2.194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M189.434 380.703H360.789",
    stroke: "#BCBCBC",
    strokeWidth: 2.194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankDataThumb);
export default __webpack_public_path__ + "static/media/blankDataThumb.5e49e2fa612592585f461c58fe50ad8f.svg";
export { ForwardRef as ReactComponent };